import { render, staticRenderFns } from "./Layout_Info.vue?vue&type=template&id=382af7ae&scoped=true&"
import script from "./Layout_Info.vue?vue&type=script&lang=js&"
export * from "./Layout_Info.vue?vue&type=script&lang=js&"
import style0 from "./Layout_Info.vue?vue&type=style&index=0&id=382af7ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382af7ae",
  null
  
)

export default component.exports